import { SubscriberValidationRequest } from '../api/subscribervalidation/subscribervalidationrequest';
import { SubscriberValidationResponse,/* , SubscriberValidationResponseDtoImpl */ 
SubscriberValidationResponseDtoImpl} from '../api/subscribervalidation/subscribervalidationresponse';
import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { StatusCodes } from '../util/statuscodes';
import { APIFeatures } from '../util/apifeatures';
import { APIProcessorImpl } from './apiProcessor';
import { Strings } from '../../utils/resources/strings';
//import { XMLHttpRequest } from 'xmlhttprequest-ts';

export class SubscriberValidationSignUpAPIProcessorImpl extends APIProcessorImpl<SubscriberValidationRequest,
    SubscriberValidationResponse>
{

    execute(request: SubscriberValidationRequest): void
     {
         super.execute(request);

        /* let xhr = new XMLHttpRequest(); //
        xhr.open("POST", 'https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/subscriber-validation', false);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
        xhr.send("{\"msisdn\":\"0504843969\",\"language\":\"English\",\"clientTxnId\":\"15042020\",\"type\":\"mytype\"}"); 

        console.log(xhr);  */

    }
    /* execute()
   {
       console.log("execute() in SubscriberValidationAPIProcessorImpl"); 

       let subscriberValidationResponse = new SubscriberValidationResponseDtoImpl(APIFeatures.SUBSCRIBER_VALIDATION, "Valid Subscriber");
       subscriberValidationResponse.setRespCode("100");
       subscriberValidationResponse.setRespDesc("Success");
       subscriberValidationResponse.setClientTxnId("15042020");
       subscriberValidationResponse.setTxnId("15042020");
       subscriberValidationResponse.setSrvType("SRVType");
           
       this.getAPISuccess(subscriberValidationResponse);
    }  */

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try{
            
            if(+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
            {
                //registered
                if(responseMapper.getStatusCodeOutside() === "SC0000")
                {
                    if(responseMapper.getResponseMap().respCode === "000" 
                                || responseMapper.getResponseMap().respCode === "SC0000")
                    {
                        let subscriberValidationResponse = new SubscriberValidationResponseDtoImpl(
                        APIFeatures.SUBSCRIBER_VALIDATION, 
                        this.getContext().getResources().getString(Strings.subscriber_already_registered));
        
                        this.getAPIFailure(subscriberValidationResponse);
                    }
                    else if(responseMapper.getResponseMap().respCode === "100")
                    {//non-registered etisalath
                        let subscriberValidationResponse = new SubscriberValidationResponseDtoImpl(
                        APIFeatures.SUBSCRIBER_VALIDATION, this.getContext().getResources().getString(Strings.valid_subscriber));
        
                        this.getAPISuccess(subscriberValidationResponse);
                    }
                    else if(responseMapper.getResponseMap().respCode === "002")
                    {//password expired/ blocked by admin
                        let subscriberValidationResponse = new SubscriberValidationResponseDtoImpl(
                        APIFeatures.SUBSCRIBER_VALIDATION, this.getContext().getResources().getString(Strings.password_blocked));
        
                        this.getAPIFailure(subscriberValidationResponse);
                    }
                    else
                    {
                        //not -registered, not-etisalath
                        let subscriberValidationResponse = new SubscriberValidationResponseDtoImpl(
                            APIFeatures.SUBSCRIBER_VALIDATION, this.getContext().getResources().getString(Strings.invalid_mpt_subscriber));
            
                            this.getAPIFailure(subscriberValidationResponse);
                    }
                }
                else
                {
                    let subscriberValidationResponse = new SubscriberValidationResponseDtoImpl(
                        APIFeatures.SUBSCRIBER_VALIDATION, this.getContext().getResources().getString(Strings.invalid_mpt_subscriber));
        
                        this.getAPIFailure(subscriberValidationResponse);
                }
            }
        }
        catch(e)
        {
            this.getAPIFailure(new SubscriberValidationResponseDtoImpl(APIFeatures.SUBSCRIBER_VALIDATION, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
       
      this.getAPIFailure(new SubscriberValidationResponseDtoImpl(APIFeatures.SUBSCRIBER_VALIDATION, 
        responseMapper.getStatusMsg()));
            
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/subscribervalidationsignupapiprocessor.tsx